import * as React from 'react';

import { useSession } from '@/components/session-provider';
import { useTenant } from '@/components/tenant-provider';
import { registerExpoPushToken } from '@/lib/notifications';
import { pushTenantIdsForMemberships } from '@/lib/push-notification-registration';

export function PushNotificationRegistration() {
  const { session } = useSession();
  const { memberships } = useTenant();
  const userId = session?.user.id;
  const attemptedRegistrations = React.useRef(new Set<string>());
  const tenantIds = React.useMemo(
    () => pushTenantIdsForMemberships(memberships, userId),
    [memberships, userId]
  );

  React.useEffect(() => {
    let active = true;

    async function registerMemberships() {
      for (const tenantId of tenantIds) {
        if (!active || !userId) {
          return;
        }

        const registrationKey = `${userId}:${tenantId}`;
        if (attemptedRegistrations.current.has(registrationKey)) {
          continue;
        }
        attemptedRegistrations.current.add(registrationKey);

        try {
          const result = await registerExpoPushToken(tenantId);
          if (result.permission === 'denied' || result.permission === 'unsupported') {
            return;
          }
        } catch {
          // App startup and navigation must remain usable if push registration is unavailable.
        }
      }
    }

    void registerMemberships();
    return () => {
      active = false;
    };
  }, [tenantIds, userId]);

  return null;
}
